import AberturaParquimetro from '@/pages/AberturaParquimetro.vue';

export default {
  path: '/abertura-parquimetro',
  name: 'AberturaParquimetro',
  components: {
    mainContent: AberturaParquimetro,
  },
  meta: {
    role: {
      sectorId: 'login',
    },
  },
};
